import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { CompanyExtRouter } from './company.router';
import { CompanyEffects } from './state/company.effects';
import { reducers } from './state/company.selectors';

@NgModule({
  imports: [
    CompanyExtRouter,
    StoreModule.forFeature('company', reducers),
    EffectsModule.forFeature([CompanyEffects]),
  ],
  declarations: []
})
export class CompanyExtScreenModule { }